import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { Alarm, Assignment, CalendarMonth, DocumentScanner, QrCode } from '@mui/icons-material'
import AppLayout from '../../../layout/components/AppLayout'
import { useAppData } from '../../../context/AppDataContext'
import { useFilteredTask } from '../../admin/erp/tasks/hook/useFilteredTask'

function AdminLandingPage() {

  const {taskList} = useAppData();

  const { toDos, reminders, leads, mine,myAssigned,highPriority,medPriority,lowPriority } = useFilteredTask(taskList);


  return (
    <AppLayout>
      <div className='container-fluid'>
        <div className='row mt-5'>


          <div className="col-md-2 col-sm-6 col-xs-6">
              <div className="card bg-primary text-white shadow  p-1">
                  <p>Todos</p>
                  <div className='d-flex justify-content-between'>
                    <span><Assignment sx={{fontSize:60}}/></span>
                    <span className='me-5'><h1 sx={{fontSize:60}}>{toDos.length}</h1></span>
                  </div>
                  
              </div>
          </div>

          <div className="col-md-2 col-sm-6 col-xs-6">
              <div className="card bg-warning text-dark shadow  p-1">
                  <p>Reminders</p>
                  <div className='d-flex justify-content-between'>
                    <span><Alarm sx={{fontSize:60}}/></span>
                    <span className='me-5'><h1 sx={{fontSize:60}}>{reminders.length}</h1></span>
                  </div>
                  
              </div>
          </div>
          <div className="col-md-2 col-sm-6 col-xs-6">
              <div className="card bg-info text-dark shadow  p-1">
                  <p>Leads</p>
                  <div className='d-flex justify-content-between'>
                    <span><CalendarMonth sx={{fontSize:60}}/></span>
                    <span className='me-5'><h1 sx={{fontSize:60}}>{leads.length}</h1></span>
                  </div>
                  
              </div>
          </div>      
        </div>

{/*
        <div className='mb-3'>{JSON.stringify(taskList)}</div>

        <div className='mb-3'>{JSON.stringify(toDos)}</div>
        <div className='mb-3'>{JSON.stringify(reminders)}</div>
        <div className='mb-3'>{JSON.stringify(leads)}</div>

        <div className='mb-3'>{JSON.stringify(mine)}</div>
        <div className='mb-3'>{JSON.stringify(myAssigned)}</div>
        <div className='mb-3'>{JSON.stringify(highPriority)}</div>
        <div className='mb-3'>{JSON.stringify(medPriority)}</div>
        <div className='mb-3'>{JSON.stringify(lowPriority)}</div>
        
*/}

      </div>
    </AppLayout>  
  )
}

export default AdminLandingPage